import { Outlet } from "react-router-dom";

export default function FarmDairyLayout() {
  return <Outlet />;
}
